import { useEffect, useRef } from 'react';

/**
 * Prefetch agresivo desactivado en tienda pública (PageSpeed + LVE I/O).
 * Las fotos cargan con lazy en ProductCard.
 */
export default function usePrefetchCatalogImages({ enabled = true } = {}) {
  const started = useRef(false);
  useEffect(() => {
    if (!enabled || started.current) return undefined;
    started.current = true;
    return undefined;
  }, [enabled]);
}
